<div class="min-h-screen w-full flex items-center justify-center px-6 py-16">
    <div class="max-w-xl w-full text-center flex flex-col items-center gap-6">
        <div>
            <i class="si-display-xl element-security text-[var(--element-text-secondary)]"></i>
        </div>

        <h1 class="text-3xl md:text-4xl font-semibold">{{'application-submitted.info' | translate}}</h1>

        <p class="text-base text-[var(--element-text-secondary)]">{{'application-submitted.thank-you' | translate}}</p>

        <button type="button" class="btn btn-primary" routerLink="/">
            {{'application-submitted.back-home' | translate}}
        </button>
    </div>
</div>
